import React, { useState, useEffect } from "react";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import useTable from "../../useTableR";
import axios from "axios";
import { EstadoCuentaInmuebleModal } from "./modalEstadoInmueble";
import { SearchInput } from "../../../ui/inputs/Input";

function TablaEstadoCuentaInmueble(props) {
  let op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));
  const [mostrarModal, setMostrarModal] = useState(false);
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const factorCambio = JSON.parse(localStorage.getItem("factorCambio"));
  const [inmueble, setInmueble] = useState();
  const [deuda, setDeuda] = useState();
  const [historico, setHistorico] = useState();

  const [fechaSistema] = useState(localStorage.getItem("fechasistema"));
  const [facturaR, setFacturaR] = useState();
  const [credito, setCredito] = useState();

  const headCells = [
    {
      id: "idinmueble",
      label: "CODIGO",
      width: "10px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "numficha",
      label: "N° FICHA",
      width: "70px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "nombrepropie",
      label: "NOMBRE PROPIETARIO",
      width: "250px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "dirinmueble",
      label: "DIRECCION",
      width: "250px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "codigocatastral",
      label: "CODIGO CATASTRAL",
      width: "100px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "cedulapropie",
      label: "CEDULA PROPIETARIO",
      width: "200px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },

    {
      id: "accion",
      label: "OPCIONES",
      width: "120px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              (x.idinmueble.includes(target.value) === null
                ? ""
                : x.idinmueble.includes(target.value)) ||
              (x.nombrepropie === null
                ? ""
                : x.nombrepropie
                    .toLowerCase()
                    .includes(target.value.toLowerCase())) ||
              (x.numficha === null
                ? ""
                : x.numficha
                    .toLowerCase()
                    .includes(target.value.toLowerCase())) ||
              (x.codigocatastral === null
                ? ""
                : x.codigocatastral
                    .toLowerCase()
                    .includes(target.value.toLowerCase())) ||
              (x.cedulapropie === null
                ? ""
                : x.cedulapropie
                    .toLowerCase()
                    .includes(target.value.toLowerCase()))
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarRegistros = () => {
    let endpoint = op.conexion + `/api/catalogo/inmuebles`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setRecords(response.data);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const SelectFacturaR = (data) => {
    let nomtab = "inmueble";

    let endpoint = `${op.conexion}/api/inmueble/relacionfacturas?idinmueble=${data.idinmueble}&nomtab=${nomtab}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setFacturaR(response.data);
          setActivate(false);
          setMostrarModal(true);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const SelectDeudaC = (data) => {
    let endpoint = `${op.conexion}/api/inmueble/deudainmueble?idinmueble=${data.idinmueble}&fecha=${fechaSistema}&espiritu=${espiritu}&tipounid=1`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          var deu = [];
          var his = [];
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].fechapago === null) {
              console.log(factorCambio?.valor);
              console.log(response.data[i].mondeu);
              deu.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: parseFloat(response.data[i].intmoradeu),
                //multa: response.data[i].multa,
                recargo: parseFloat(response.data[i].recargodeu),
              });
            } else {
              his.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                recargo: response.data[i].recargodeu,
                //multa: response.data[i].multa,
                descuento: response.data[i].mondescue,
                recibo: response.data[i].numreci,
                fechapago: response.data[i].fechapago,
              });
            }
          }

          setDeuda(deu);
          setHistorico(his);
          SelectFacturaR(data);
        } else {
          SelectFacturaR(data);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const seleccionarRegistro = (idinmueble) => (e) => {
    e.preventDefault();

    let campos = "*";
    let nomtab = "inmueble";
    let nomid = "idinmueble";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idinmueble}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idinmueble > 0) {
            setInmueble(response.data);
            setCredito(response.data.credito);
            SelectDeudaC(response.data);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };
  const cerrarModalActualizar = () => {
    setMostrarModal(false);
  };
  useEffect(() => {
    seleccionarRegistros();
  }, []);
  const cerrar = () => {
    props.menu();
  };
  return (
    <div className="col-8 m-0 p-2 border rounded">
      <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">Estado de Cuenta Inmuebles Urbanos</h3>
        <a type="button" onClick={cerrar} className="text-light fw-bold fs-6">
          Salir <i className="fas fa-times ms-2"></i>
        </a>
      </header>
      <div className="col-4 m-0 my-2 p-0">
        <SearchInput placeholder="Buscar" onChange={handleSearch} />
      </div>
      <div className="col-12 m-0 p-0">
        <TblContainer>
          <TblHead />

          <tbody>
            {records &&
              recordsAfterPagingAndSorting().map((item, index) => (
                <tr key={item.idinmueble} style={{ padding: "0" }}>
                  <td
                    className="align-baseline"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "10px",
                    }}
                  >
                    {item.idinmueble}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "70px",
                    }}
                  >
                    {item.numficha}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      fontSize: "10px",
                      textAlign: "left",
                      width: "250px",
                    }}
                  >
                    {item.nombrepropie}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      fontSize: "10px",
                      textAlign: "left",
                      width: "250px",
                    }}
                  >
                    {item.dirinmueble}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      fontSize: "10px",
                      textAlign: "left",
                      width: "100px",
                    }}
                  >
                    {item.codigocatastral}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "200px",
                    }}
                  >
                    {item.cedulapropie}
                  </td>

                  <td
                    className="align-baseline"
                    align="center"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "200px",
                    }}
                  >
                    {/* <button style={{ width: "120px" }} onClick={seleccionarRegistro(item.idinmueble)} className="btn btn-outline-info"><i className="fas fa-edit">Seleccionar</i> </button> */}
                    <button
                      className="btn btn-sm btn-info rounded-pill"
                      onClick={seleccionarRegistro(item.idinmueble)}
                    >
                      <i className="fa fa-search">Consultar </i>{" "}
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </TblContainer>
        <TblPagination />
      </div>
      <EstadoCuentaInmuebleModal
        show={mostrarModal}
        onHideCancela={cerrarModalActualizar}
        inmueble={inmueble}
        deuda={deuda}
        historico={historico}
        facturaR={facturaR}
        factorCambio={factorCambio?.valor}
        credito={credito}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />

      <Dimmer active={activate} inverted></Dimmer>
    </div>
  );
}

export default TablaEstadoCuentaInmueble;
